<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">
          {{ isViewMode ? 'View Position' : isEditMode ? 'Edit Position' : 'Create New Position' }}
        </div>
      </ion-col>
      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>
    <div class="form-scroll-container" style="padding: 0rem !important;">

      <form [formGroup]="positionForm">
        <ion-grid>
          <ion-row>
            <ion-col size="6">
              <label class="formLabelRegularfs16 mb-5">Position Category<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select" formControlName="positionCategory">
                  <mat-option *ngFor="let category of categories" [value]="category">{{ category }}</mat-option>
                </mat-select>
                <mat-error *ngIf="positionForm.get('positionCategory')?.hasError('required')">Position Category is
                  required</mat-error>

              </mat-form-field>
              <!-- <div *ngIf="positionForm.get('positionCategory')?.value === 'Vacant Position'" style="margin-top: 5px;">
                Inline note capture for vacant positions in requisition
              </div> -->
            </ion-col>
            <ion-col size="6">
              <label class="formLabelRegularfs16 mb-5">Band<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style" appearance="fill">
                <input type="text" matInput [formControl]="bandControl" [matAutocomplete]="autoBand"
                  (blur)="onBandBlur()" placeholder="Enter or select band" />
                <mat-autocomplete #autoBand="matAutocomplete">
                  <mat-option *ngFor="let band of filteredBands" [value]="band.band">
                    {{ band.band }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="bandControl?.hasError('required')">Band is required</mat-error>
                <mat-error *ngIf="bandControl?.hasError('maxlength')">
                  Maximum 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>

          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">
                Position Name<span class="red-cl"> *</span>
              </label>

              <mat-form-field class="w-100 mat-height40 mat-input-style">

                <ng-container [ngSwitch]="positionForm.get('positionCategory')?.value">
                  <!-- New Position -->
                  <input *ngSwitchCase="'New Position'" matInput placeholder="Enter New Position"
                    formControlName="positionName" />

                  <!-- Vacant Position -->
                  <mat-select *ngSwitchCase="'Vacant Position'" placeholder="Select Vacant Position"
                    formControlName="positionName">
                    <mat-option *ngFor="let pos of vacantPositions" [value]="pos.name">
                      {{ pos.name }}
                    </mat-option>
                  </mat-select>

                  <!-- Default Fallback (nothing chosen yet) -->
                  <input *ngSwitchDefault matInput placeholder="Enter position name" formControlName="positionName" />
                </ng-container>

                <!-- Error -->
                <mat-error *ngIf="positionForm.get('positionName')?.hasError('required')">
                  Position Name is required
                </mat-error>
                <mat-error *ngIf="positionForm.get('positionName')?.hasError('maxlength')">
                  Maximum 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>


            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Number of Vacancies<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="number" min="1" placeholder="Enter number of vacancies"
                  formControlName="numberOfVacancies" />
                <mat-error *ngIf="positionForm.get('numberOfVacancies')?.hasError('required')">Number of Vacancies is
                  required</mat-error>
                <mat-error *ngIf="positionForm.get('numberOfVacancies')?.hasError('min')">Must be at least 1</mat-error>
                <mat-error *ngIf="positionForm.get('numberOfVacancies')?.hasError('pattern')">
                  Must be an integer
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Year of Experience<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="number" min="0" max="99" placeholder="Enter years of experience"
                  formControlName="experienceYears" (input)="onExperienceInput($event)" />
                <mat-error *ngIf="positionForm.get('experienceYears')?.hasError('required')">Experience is
                  required</mat-error>
                <mat-error *ngIf="positionForm.get('experienceYears')?.hasError('min')">Must be at least 0</mat-error>
                <mat-error *ngIf="positionForm.get('experienceYears')?.hasError('max')">
                  Maximum 99 years allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Salary Range <span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="e.g., 3 LPA - 5 LPA" formControlName="salaryRange" />
                <mat-error *ngIf="positionForm.get('salaryRange')?.hasError('required')">Salary Range is
                  required</mat-error> <mat-error *ngIf="positionForm.get('salaryRange')?.hasError('maxlength')">
                  Maximum 50 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Skills<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="e.g., Angular, TypeScript" formControlName="skills" />
                <mat-error *ngIf="positionForm.get('skills')?.hasError('required')">Skills are required</mat-error>
                <mat-error *ngIf="positionForm.get('skills')?.hasError('maxlength')">
                  Maximum 200 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Highest Education<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="e.g., B.Tech, M.Sc" formControlName="education" />
                <mat-error *ngIf="positionForm.get('education')?.hasError('required')">Education is required</mat-error>
                <mat-error *ngIf="positionForm.get('education')?.hasError('maxlength')">
                  Maximum 200 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">
                Designation<span class="red-cl"> *</span>
              </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style" appearance="fill">
                <input type="text" matInput formControlName="designation" [matAutocomplete]="autoDesignation"
                  placeholder="Enter or select designation" />
                <mat-autocomplete #autoDesignation="matAutocomplete">
                  <mat-option *ngFor="let d of filteredDesignations" [value]="d.designation">
                    {{ d.designation }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="positionForm.get('designation')?.hasError('required')">
                  Designation is required
                </mat-error>
                <mat-error *ngIf="positionForm.get('designation')?.hasError('maxlength')">
                  Maximum 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">
                Job Posting<span class="red-cl"> *</span>
              </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select" formControlName="jobPosting" [multiple]="true">
                  <mat-option *ngFor="let type of jobPostingTypes" [value]="type">
                    {{ type }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="positionForm.get('jobPosting')?.hasError('required')">
                  Job Posting is required
                </mat-error>
              </mat-form-field>
            </ion-col>

          </ion-row>

          <ion-row> 
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Department<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style" appearance="fill"> 
                <input type="text" matInput [formControl]="departmentControl" [matAutocomplete]="autoDepartment"
                  (blur)="onDepartmentBlur()" placeholder="Enter or select department"
               />

                <mat-autocomplete #autoDepartment="matAutocomplete">
                  <mat-option *ngFor="let dept of filteredDepartments" [value]="dept.department">
                    {{ dept.department }}
                  </mat-option>
                </mat-autocomplete>

                <mat-error *ngIf="departmentControl?.hasError('required')">Department is required</mat-error>
                <mat-error *ngIf="positionForm.get('department')?.hasError('maxlength')">
                  Maximum 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Location<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style" appearance="fill">
                <input type="text" matInput [formControl]="locationControl" [matAutocomplete]="autoLocation"
                  (blur)="onLocationBlur()" placeholder="Enter or select location" />
                <mat-autocomplete #autoLocation="matAutocomplete">
                  <mat-option *ngFor="let loc of filteredLocations" [value]="loc.location">
                    {{ loc.location }}
                  </mat-option>
                </mat-autocomplete> <mat-error *ngIf="locationControl?.hasError('required')">Location is
                  required</mat-error>
                <mat-error *ngIf="positionForm.get('location')?.hasError('maxlength')">
                  Maximum 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Position Open Date</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="Select date" readonly
                  [value]="positionForm.get('positionOpenDate')?.value | date:'dd/MM/yyyy'" />
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Position Closing Date<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style" appearance="fill">
                <input matInput [min]="minClosingDate" [matDatepicker]="closingPicker"
                  formControlName="positionClosingDate" placeholder="Select closing date" readonly
                  (focus)="closingPicker.open()" (click)="closingPicker.open()" />
                <mat-datepicker-toggle matSuffix [for]="closingPicker"></mat-datepicker-toggle>
                <mat-datepicker #closingPicker></mat-datepicker>
                <mat-error *ngIf="positionForm.get('positionClosingDate')?.hasError('required')">Position Closing Date is
                  required</mat-error> 
              </mat-form-field>
             
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Tech Position<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select tech position" formControlName="techPosition">
                  <mat-option *ngFor="let pos of techPositions" [value]="pos.name">{{ pos.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="positionForm.get('techPosition')?.hasError('required')">Tech Position is
                  required</mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">HOD(s)</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select HOD(s)" formControlName="hodIdList" multiple
                  [compareWith]="compareHodFn">
                  <mat-option *ngFor="let hod of filteredHODs" [value]="hod">
                    {{ hod.hod_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>

          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Lead_Interviewer<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select lead interviewer" formControlName="leadInterviewer"
                  [compareWith]="compareFn" multiple>
                  <mat-option *ngFor="let member of panelMembers" [value]="member">{{ member.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="positionForm.get('leadInterviewer')?.hasError('required')">Lead Interviewer is
                  required</mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Interview Panel Members<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select panel members" formControlName="interviewPanelMembers" multiple
                  [compareWith]="compareFn">
                  <mat-option *ngFor="let member of panelMembers" [value]="member"> {{ member.name }}</mat-option>
                </mat-select> <mat-error *ngIf="positionForm.get('interviewPanelMembers')?.hasError('required')">At
                  least one panel member is required</mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Job Platforms</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select formControlName="jobPlatforms" [disabled]="isViewMode" multiple
                  placeholder="Select Job Platforms">
                  <mat-option *ngFor="let platform of jobPlatformsList" [value]="platform.jobPlatformName">
                    {{ platform.jobPlatformName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Job Description<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-input-style">
                <textarea matInput rows="3" formControlName="jobDescription"
                  placeholder="Enter detailed job description"></textarea> <mat-error
                  *ngIf="positionForm.get('jobDescription')?.hasError('required')">Job Description is
                  required</mat-error> <mat-error *ngIf="positionForm.get('jobDescription')?.hasError('maxlength')">
                  Maximum 2000 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="!isViewMode">
            <ion-col size="12" class="text-right mt-10">
              <button class="back_btn fs-14" (click)="onClose()">Cancel</button>
              <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"
                [disabled]="isSubmitting" (click)="onSubmit()">
                {{ isEditMode ? 'Update Position' : 'Create Position' }}
              </button>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="isViewMode">
            <ion-col size="12" class="text-right mt-10">
              <button class="add_btn fs-14" (click)="onApply()">Apply Now</button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </div>
  </div>
</div>